"use client";
import toast from "react-hot-toast";
import axios from "axios";
import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";

const useSearchProducts = () => {
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const location = useSelector((state: AppState) => state.location);

	const fetchSearchProducts = async (
		query: any,
		callback: (results: any[]) => void
	) => {
		if (!location?.activeLocation?.id) return;

		try {
			const response = await axios.get(`${base_url}/api/drinks-name`, {
				params: {
					productName: query,
					branchId: location.activeLocation.id,
				},
			});
			callback(response.data.products);
		} catch (error: string | any) {
			// console.error("API error", error);
			toast.remove();
			toast.error(`Error: ${error?.response?.data?.error}`);
		}
	};

	return {
		fetchSearchProducts,
	};
};

export default useSearchProducts;
